// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import './ConnectRequiredInfoDoc.scss';

type ConnectRequiredInfoDocProps = {|
  id?: string,
  className?: string,
  children: React.Node,
|};

export const ConnectRequiredInfoDoc = ({
  id,
  className,
  children,
}: ConnectRequiredInfoDocProps) => {
  return (
    <Box
      margin={{top: 20}}
      className={classNames('ConnectRequiredInfoDoc', className)}
    >
      {children}
    </Box>
  );
};
